export default function closeDropdowns(className, element, setState) {
    document.querySelectorAll(className).forEach(btn => {
        btn.addEventListener('click', (e) => {
            if (e.target !== element) setState(false)
        })
    })
}